var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.678 10.897l.14.206c.12.172.35.213.523.097l1.993-1.372a.369.369 0 00.163-.31V5.376A.376.376 0 008.122 5h-.25a.376.376 0 00-.375.375v3.813l-1.725 1.187a.381.381 0 00-.094.522zM3.2 14.094l-1.053 1.053a.499.499 0 10.706.706l1.125-1.125A6.947 6.947 0 008 16a6.947 6.947 0 004.022-1.272l1.125 1.125a.499.499 0 10.706-.706L12.8 14.094A6.971 6.971 0 0015 9c0-1.178-.29-2.29-.806-3.266A3.498 3.498 0 0011.5 0a3.5 3.5 0 00-3.166 2.006 7.875 7.875 0 00-.665 0A3.506 3.506 0 004.5 0a3.498 3.498 0 00-2.694 5.734A6.967 6.967 0 001 9c0 2.006.844 3.819 2.2 5.094zM6.597 2.14A7 7 0 002.38 4.825 2.487 2.487 0 012 3.5C2 2.122 3.122 1 4.5 1c.878 0 1.65.456 2.097 1.14zM14 3.5c0 .487-.14.94-.381 1.325a7.009 7.009 0 00-4.216-2.684A2.504 2.504 0 0111.5 1C12.878 1 14 2.122 14 3.5zM8 3c3.313 0 6 2.688 6 6 0 3.313-2.688 6-6 6-3.313 0-6-2.688-6-6 0-3.313 2.688-6 6-6z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/delay.2d1d8b80c60bb4badfcc18fe3e1d1180.svg";
export { SvgDelay as ReactComponent };